import React from 'react';
import {RegulationComponentsCommon} from "../../regulation-components-common";
import {NetherlandsMinimumGamblingAgeComponent} from "../../../../components/responsible-gambling/minimum-gambling-age/regulations/netherlands/netherlands.minimum-gambling-age.component";
import {NetherlandsSelfTestButtonComponent} from "../../../../components/responsible-gambling/responsible-gaming-buttons/regulations/netherlands/self-test-button/netherlands.self-test-button.component";

export class NetherlandsRegulationComponents extends RegulationComponentsCommon {
    renderHeaderMinimumGamblingAge() {
        return(<NetherlandsMinimumGamblingAgeComponent isShownInHeader={true}/>);
    }

    renderHeaderRegulationIcons() {
        return (
            <NetherlandsSelfTestButtonComponent/>
        );
    }
}